import * as Yup from "yup";

const equipamentoValidator = Yup.object().shape({
  valorAquisicao: Yup.number()
    .required("Valor de Aquisição")
    .min(0.01, "Valor de Aquisição deve ser maior ou igual a 0.01"),
  vidaUtil: Yup.number()
    .required("Vida Útil")
    .min(1, "Vida Útil deve ser maior ou igual a 1"),
  manutencaoMensal: Yup.number()
    .required("Manutenção Mensal")
    .min(0, "Manutenção Mensal deve ser maior ou igual a 0"),
  horasUsoMes: Yup.number()
    .required("Horas de uso/mês")
    .min(1, "Horas de uso/mês deve ser maior ou igual a 1"),
  depreciacao: Yup.number().required("Depreciação"),
  custoMensal: Yup.number().required("Custo Mensal"),
  custoHora: Yup.number()
    .required("Custo/Hora")
    .min(0.01, "Custo/Hora deve ser maior ou igual a 0.01"),
});

const equipamentoListValidator = Yup.array().of(equipamentoValidator);

export { equipamentoValidator, equipamentoListValidator };
